import Vue from 'vue';
import VueI18n, { MissingHandler } from 'vue-i18n';
import messages from './locales/de';

Vue.use(VueI18n);

const missing: MissingHandler = (
  locale: string,
  key: string,
  vm: Vue | null,
  values: any
) => {
  return `{${key.toLocaleUpperCase()}}`;
};

class CustomFormatter {
  interpolate(message: string | number, values: any, path: string) {
    return [message || `[${path.toLocaleUpperCase()}]`];
  }
}

const formatter = new CustomFormatter();

const loadedLanguages: string[] = ['loc'];

export const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  missing,
  formatter,
  messages,
  silentTranslationWarn: true,
});

function setI18nLanguage(lang: string) {
  i18n.locale = lang;
  (window as any).axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html')?.setAttribute('lang', lang);
  return lang;
}

export function loadLanguageAsync(lang: string, messages: any) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  i18n.setLocaleMessage(lang, messages);
  loadedLanguages.push(lang);
  return Promise.resolve(setI18nLanguage(lang));
}
